import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LoggingService } from '@com-delta-idp/mnx-utils';
import { Observable, of } from 'rxjs';
import { catchError, map, share } from 'rxjs/operators';
import { ApplicationConfig } from '../config/config';
import { ClosestAirportModel } from '../model/closest-airport.model';

@Injectable({
  providedIn: 'root'
})
export class ClosestAirPortcode {
  public closestAirport: ClosestAirportModel;
  private closestAirportObserver: Observable<any>;

  constructor(
    private http: HttpClient,
    private config: ApplicationConfig,
    private loggingService: LoggingService
  ) {}

  getClosestDeltaAirportCode() {
    if (this.closestAirport) {
      return of(this.closestAirport);
    } else if (this.closestAirportObserver) {
      return this.closestAirportObserver;
    } else {
      this.closestAirportObserver = this.http
        .get(`${this.config.get('APP_PREF_GEOLOCATION_URL')}`)
        .pipe(
          map((data) => {
            this.closestAirportObserver = null;
            if (this.validateClosestAirport(data)) {
              this.closestAirport = new ClosestAirportModel(
                data['airportcode'],
                data['cityname'],
                data['statecode'],
                data['countrycode']
              );
            }
            return this.closestAirport;
          }),
          catchError((e) => {
            this.loggingService.log('Caught Error: ' + e);
            return of(this.closestAirport);
          })
        )
        .pipe(share());
      return this.closestAirportObserver;
    }
  }

  validateClosestAirport(data): boolean {
    const { airportcode, cityname, statecode, countrycode } = data;
    return (
      this.validateAirportCode(airportcode) &&
      !!(cityname && statecode && countrycode)
    );
  }

  validateAirportCode(airportcode: string): boolean {
    const hasThreeChar = /^[A-Z]{3}$/.test(airportcode);
    return hasThreeChar;
  }
}
